module.exports = __webpack_public_path__ + "img/isPro2_1.9f27b238.png";